export function calculateCrossSlopeFromRadius(designClass, radius)
{
    if(designClass.id === "h1-80" || designClass.id === "h1-90" || designClass.id === "h2-90" || designClass.id === "h3-90" || designClass.id === "h3-100" || designClass.id === "h3-110")
    {
        if(Math.abs(radius) <= 700)
        {
            return 0.08;
        }
        else if(Math.abs(radius) > 700 && Math.abs(radius) < 1750)
        {
            return Math.round(((-1 / 21000) * Math.abs(radius) + (17/150))*1000)/1000;
        }
        else if(Math.abs(radius) >= 1750)
        {
            return 0.03;
        }
    }
}